const STORE_ROOT = 'OG_STATE';

export const loadState = () => {
  try {
    const serializedState = localStorage.getItem(STORE_ROOT);
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const saveState = state => {
  const serializedState = JSON.stringify({
    optedin: [...state.optedin],
    sessionId: state.sessionId,
    productOffer: state.productOffer
    // uncomment this to see parameter saved to localStorage
    // inStock: state.inStock,
    // autoshipEligible: state.autoshipEligible,
    // productOffer: state.productOffer
    // frequency: { ...state.frequency }
  });
  localStorage.setItem(STORE_ROOT, serializedState);
};

export const clearState = () => localStorage.removeItem(STORE_ROOT);
